/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 * @param {*} obj
 * @param {*} path EX: some.path.c
 * @param {*} defaultValue
 */
const get = (obj, path, defaultValue = null) => {
  const levels = path.split('.');
  return levels.reduce((xs, x) => (xs && xs[x] ? xs[x] : defaultValue), obj);
};

export { get };
